import styled from 'styled-components';
import type { ExtendedTheme } from '@theme/theme';

export const StyledThemeSwitcherWrapper = styled.div`
  ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('lg')} {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
  }
`;

export const StyledThemeDivider = styled.div`
  border-top: 1px solid ${({ theme }: { theme: ExtendedTheme }) => theme.palette.divider};
  position: relative;
  margin-bottom: 18px;
`;

export const StyledThemeSwitcher = styled.div`
  position: relative;
  box-sizing: border-box;
  width: ${({ theme }: { theme: ExtendedTheme }) => theme.shape.tocWidth}px;
  height: 40px;
  border-radius: ${({ theme }: { theme: ExtendedTheme }) => theme.shape.borderRadius}px;
  background: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.secondary.main};
  padding: 5px;
  display: flex;
  font-size: ${({ theme }: { theme: ExtendedTheme }) => theme.typography.fontSize}px;
  cursor: pointer;
  user-select: none;
  margin: 0 32px;

  ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('lg')} {
    margin: 0 auto;
  }

  &::after {
    content: '';
    position: absolute;
    background-color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.background.default};
    width: 105px;
    height: 30px;
    border-radius: 3px;
    top: 0;
    left: 0;
    transition: all 0.3s;
    transform: translate(5px, 5px);
    z-index: 50;
  }
  &.dark::after {
    background-color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.secondary.main};
    transform: translate(110px, 5px);
  }

  .theme-switcher {
    &__icon {
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-position: center center;

      &--light {
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.0002 5.83337C7.70016 5.83337 5.8335 7.70004 5.8335 10C5.8335 12.3 7.70016 14.1667 10.0002 14.1667C12.3002 14.1667 14.1668 12.3 14.1668 10C14.1668 7.70004 12.3002 5.83337 10.0002 5.83337ZM1.66683 10.8334H3.3335C3.79183 10.8334 4.16683 10.4584 4.16683 10C4.16683 9.54171 3.79183 9.16671 3.3335 9.16671H1.66683C1.2085 9.16671 0.833496 9.54171 0.833496 10C0.833496 10.4584 1.2085 10.8334 1.66683 10.8334ZM16.6668 10.8334H18.3335C18.7918 10.8334 19.1668 10.4584 19.1668 10C19.1668 9.54171 18.7918 9.16671 18.3335 9.16671H16.6668C16.2085 9.16671 15.8335 9.54171 15.8335 10C15.8335 10.4584 16.2085 10.8334 16.6668 10.8334ZM9.16683 1.66671V3.33337C9.16683 3.79171 9.54183 4.16671 10.0002 4.16671C10.4585 4.16671 10.8335 3.79171 10.8335 3.33337V1.66671C10.8335 1.20837 10.4585 0.833374 10.0002 0.833374C9.54183 0.833374 9.16683 1.20837 9.16683 1.66671ZM9.16683 16.6667V18.3334C9.16683 18.7917 9.54183 19.1667 10.0002 19.1667C10.4585 19.1667 10.8335 18.7917 10.8335 18.3334V16.6667C10.8335 16.2084 10.4585 15.8334 10.0002 15.8334C9.54183 15.8334 9.16683 16.2084 9.16683 16.6667ZM4.99183 3.81671C4.66683 3.49171 4.1335 3.49171 3.81683 3.81671C3.49183 4.14171 3.49183 4.67504 3.81683 4.99171L4.70016 5.87504C5.02516 6.20004 5.5585 6.20004 5.87516 5.87504C6.19183 5.55004 6.20016 5.01671 5.87516 4.70004L4.99183 3.81671ZM15.3002 14.125C14.9752 13.8 14.4418 13.8 14.1252 14.125C13.8002 14.45 13.8002 14.9834 14.1252 15.3L15.0085 16.1834C15.3335 16.5084 15.8668 16.5084 16.1835 16.1834C16.5085 15.8584 16.5085 15.325 16.1835 15.0084L15.3002 14.125ZM16.1835 4.99171C16.5085 4.66671 16.5085 4.13337 16.1835 3.81671C15.8585 3.49171 15.3252 3.49171 15.0085 3.81671L14.1252 4.70004C13.8002 5.02504 13.8002 5.55837 14.1252 5.87504C14.4502 6.19171 14.9835 6.20004 15.3002 5.87504L16.1835 4.99171ZM5.87516 15.3C6.20016 14.975 6.20016 14.4417 5.87516 14.125C5.55016 13.8 5.01683 13.8 4.70016 14.125L3.81683 15.0084C3.49183 15.3334 3.49183 15.8667 3.81683 16.1834C4.14183 16.5 4.67516 16.5084 4.99183 16.1834L5.87516 15.3Z' fill='%23141414'/%3E%3C/svg%3E");
      }

      &--dark {
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.80833 2.59167C5.65833 3.125 5.58333 3.68333 5.58333 4.25C5.58333 7.65 8.35 10.4167 11.75 10.4167C12.3167 10.4167 12.875 10.3417 13.4083 10.1917C12.5417 12.325 10.4417 13.8333 8 13.8333C4.78333 13.8333 2.16667 11.2167 2.16667 8C2.16667 5.55833 3.675 3.45833 5.80833 2.59167ZM8 0.5C3.85833 0.5 0.5 3.85833 0.5 8C0.5 12.1417 3.85833 15.5 8 15.5C12.1417 15.5 15.5 12.1417 15.5 8C15.5 7.61667 15.4667 7.23333 15.4167 6.86667C14.6 8.00833 13.2667 8.75 11.75 8.75C9.26667 8.75 7.25 6.73333 7.25 4.25C7.25 2.74167 7.99167 1.4 9.13333 0.583333C8.76667 0.533333 8.38333 0.5 8 0.5Z' fill='%23141414' fill-opacity='0.72'/%3E%3C/svg%3E");
      }
    }

    &__text {
      width: 100%;
      max-width: 40px;
      margin-left: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 14px;
    }

    &__light,
    &__dark {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 100;
      width: 105px;
      box-sizing: border-box;
      border: none;
      background: none;
      font-family: inherit;
    }

    &__light {
      color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.primary};
    }

    &__dark {
      color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.secondary};
    }
  }

  &.dark {
    background: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.background.default};
    .theme-switcher {
      &__icon {
        &--light {
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 7.27273C11.5 7.27273 12.7273 8.5 12.7273 10C12.7273 11.5 11.5 12.7273 10 12.7273C8.5 12.7273 7.27273 11.5 7.27273 10C7.27273 8.5 8.5 7.27273 10 7.27273ZM10 5.45455C7.49091 5.45455 5.45455 7.49091 5.45455 10C5.45455 12.5091 7.49091 14.5455 10 14.5455C12.5091 14.5455 14.5455 12.5091 14.5455 10C14.5455 7.49091 12.5091 5.45455 10 5.45455ZM0.909091 10.9091H2.72727C3.22727 10.9091 3.63636 10.5 3.63636 10C3.63636 9.5 3.22727 9.09091 2.72727 9.09091H0.909091C0.409091 9.09091 0 9.5 0 10C0 10.5 0.409091 10.9091 0.909091 10.9091ZM17.2727 10.9091H19.0909C19.5909 10.9091 20 10.5 20 10C20 9.5 19.5909 9.09091 19.0909 9.09091H17.2727C16.7727 9.09091 16.3636 9.5 16.3636 10C16.3636 10.5 16.7727 10.9091 17.2727 10.9091ZM9.09091 0.909091V2.72727C9.09091 3.22727 9.5 3.63636 10 3.63636C10.5 3.63636 10.9091 3.22727 10.9091 2.72727V0.909091C10.9091 0.409091 10.5 0 10 0C9.5 0 9.09091 0.409091 9.09091 0.909091ZM9.09091 17.2727V19.0909C9.09091 19.5909 9.5 20 10 20C10.5 20 10.9091 19.5909 10.9091 19.0909V17.2727C10.9091 16.7727 10.5 16.3636 10 16.3636C9.5 16.3636 9.09091 16.7727 9.09091 17.2727ZM4.53636 3.25455C4.18182 2.9 3.6 2.9 3.25455 3.25455C2.9 3.60909 2.9 4.19091 3.25455 4.53636L4.21818 5.5C4.57273 5.85455 5.15455 5.85455 5.5 5.5C5.84545 5.14545 5.85455 4.56364 5.5 4.21818L4.53636 3.25455ZM15.7818 14.5C15.4273 14.1455 14.8455 14.1455 14.5 14.5C14.1455 14.8545 14.1455 15.4364 14.5 15.7818L15.4636 16.7455C15.8182 17.1 16.4 17.1 16.7455 16.7455C17.1 16.3909 17.1 15.8091 16.7455 15.4636L15.7818 14.5ZM16.7455 4.53636C17.1 4.18182 17.1 3.6 16.7455 3.25455C16.3909 2.9 15.8091 2.9 15.4636 3.25455L14.5 4.21818C14.1455 4.57273 14.1455 5.15455 14.5 5.5C14.8545 5.84545 15.4364 5.85455 15.7818 5.5L16.7455 4.53636ZM5.5 15.7818C5.85455 15.4273 5.85455 14.8455 5.5 14.5C5.14545 14.1455 4.56364 14.1455 4.21818 14.5L3.25455 15.4636C2.9 15.8182 2.9 16.4 3.25455 16.7455C3.60909 17.0909 4.19091 17.1 4.53636 16.7455L5.5 15.7818Z' fill='white' fill-opacity='0.72'/%3E%3C/svg%3E%0A");
        }

        &--dark {
          background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0.5C3.85833 0.5 0.5 3.85833 0.5 8C0.5 12.1417 3.85833 15.5 8 15.5C12.1417 15.5 15.5 12.1417 15.5 8C15.5 7.61667 15.4667 7.23333 15.4167 6.86667C14.6 8.00833 13.2667 8.75 11.75 8.75C9.26667 8.75 7.25 6.73333 7.25 4.25C7.25 2.74167 7.99167 1.4 9.13333 0.583333C8.76667 0.533333 8.38333 0.5 8 0.5Z' fill='white'/%3E%3C/svg%3E%0A");
        }
      }
      &__light {
        color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.secondary};
      }

      &__dark {
        color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.primary};
      }
    }
  }
`;
